import { makeObservable, observable, runInAction } from 'mobx';
import { ReservationService } from '@data/api';
import { Property, Reservation as ReservationModel } from '@data/models';
import { Guest } from '@data/models';
import Payment from '@data/models/Payment';
import ReservationItem from '@data/models/ReservationItem';
import { notificationError } from '@view/utils/notifications';

export default class Reservation {
  @observable model: ReservationModel | null = null;
  @observable reservationCode: string | null = null;

  constructor() {
    makeObservable(this);
  }

  async make(
    property: Property,
    items: ReservationItem[],
    checkin: Date,
    checkout: Date,
    guests: Guest[],
    payment: Payment
  ) {
    runInAction(() => {
      this.model = null;
      this.reservationCode = null;
    });
    const makeResult = await ReservationService.makeReservation(
      property,
      items,
      checkin,
      checkout,
      guests,
      payment
    );
    if (makeResult?.status) {
      runInAction(() => {
        this.reservationCode = makeResult.enc_res_id;
      });

      if (this.reservationCode) {
        await this.get(this.reservationCode);
      }
    } else {
      throw new Error('payment processing error');
    }
    return makeResult;
  }

  async get(reservationCode: string) {
    const result = await ReservationService.getReservation(reservationCode);
    runInAction(() => {
      this.reservationCode = reservationCode;
      this.model = result;
    });
  }
}
